import { useMemo } from "react";
import useNewDataFetcher from "../../../../Hooks/newUseDataFetcher";
import GraphTable from "../../../../Components/GraphTable";
import SubheaderTimePeriod from "../../../../Components/SubheaderTimePeriod";

function ByClient() {
  const dataURL = "/api/v1/activity/record-counts/client"
  const { data, dateRange, filterTypes, filters, isReady } = useNewDataFetcher({
    endPoint: dataURL,
  });

  const contactsAdded = useMemo(() => {
    if (!data) return 0;
    let total = data.data.reduce((acc, cur) => {
      acc += cur.contactAdded || 0;
      return acc;
    }, 0);
    return total;
  }, [data]);

  return (
    <GraphTable data={data} dateRange={dateRange} interval={dateRange.interval} filterTypes={filterTypes} filters={filters} isReady={isReady} dataURL={dataURL}>
      <h1 className="page-heading">Are we building our database?</h1>
      <h2 className="page-subheading">
        <span className="page-data">{contactsAdded}</span> contacts added <SubheaderTimePeriod data={dateRange} />
      </h2>
    </GraphTable>
  );
}

export default ByClient;
